// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"8d220b12","477":"d923ba96"}[chunkId] + ".chunk.js";
};